// This component is scoped out of CSS Editing for now, will be added in the future
const semanticClassNames = {
  root: 'search-bar',
  icon: 'search-bar__icon',
  input: 'search-bar__input',
} as const;

export default semanticClassNames;
